import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
      <div className="App">
        <svg id="loading-bar" xmlns="http://www.w3.org/2000/svg" width="36" height="22" viewBox="0 0 36 22">
          <g>
            <rect id="loading-bar-left" width="8" height="22"/>
            <rect id="loading-bar-middle" width="8" height="22" x="14"/>
            <rect id="loading-bar-right" width="8" height="22" x="28"/>
          </g>
        </svg>
      </div>
  </React.StrictMode>,
  document.getElementById('root')
);
  const rootElement = document.getElementById("root");
  ReactDOM.render(<App />, rootElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
